export default __webpack_public_path__ + "images/d6cf1c5e88fda959655350fe6d7c62d2.webp";